import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import iosButton from "assets/images/coming-soon/ios-button.png";
import googleButton from "assets/images/coming-soon/google-button.png";
import huaweiButton from "assets/images/coming-soon/huawei-button.png";
import qrcode from "assets/images/coming-soon/qr-code.png";
import BannerImage from "assets/images/coming-soon/AppStore_right.png";

function InstallApp() {
  return (
    <div className="container">
      <Container fluid className="inward-container">
        <Row>
          <div data-aos="fade-up" data-aos-delay="150">
            <h1 className="heading mb-5">2 ways to get the MY alrajhi app</h1>
          </div>
          <Row className="align-items-center flex-column-reverse flex-lg-row mx-auto">
            <Col>
              <div
                className="col aos-init"
                data-aos="fade-left"
                data-aos-delay="150"
              >
                <center className="content-container">
                  <div className="coming-soon-image-container">
                    <img
                      src={qrcode}
                      alt="QR Code"
                      className="d-block"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div className="qr-content-container">
                    <h3>Scan this QR code</h3>
                    <p>
                      Use your phone’s camera to scan the code and download the
                      app
                    </p>
                  </div>
                </center>
                <Row className="d-flex align-items-center my-3 mx-2">
                  <Col md={5} xs={4}>
                    <div className="divider"></div>
                  </Col>
                  <Col md={2} xs={4}>
                    <h5 className="divider-title">Or</h5>
                  </Col>
                  <Col md={5} xs={4}>
                    <div className="divider"></div>
                  </Col>
                </Row>
                <div className="content-container">
                  <div className="qr-content-container">
                    <h3>Download the app</h3>
                    <p>
                      Find the MY alrajhi app in the App Store, Google Play and
                      HUAWEI AppGallery.
                    </p>
                    <div className="col" style={{ paddingBottom: "0px" }}>
                      <div className="ccm-custom-style-container  ccm-custom-style-downloadsectionbuttons-353">
                        <p className="d-flex flex-column flex-md-row justify-content-between gap-4 gap-md-2 m-0">
                          <a
                            href="https://apps.apple.com/app/rize-my/id1587293861"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              maxWidth: "200px",
                              margin: "0 auto",
                            }}
                          >
                            <img
                              src={iosButton}
                              alt="Download on iOS"
                              width="100%"
                              height="auto"
                            />
                          </a>
                          <a
                            href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              maxWidth: "200px",
                              margin: "0 auto",
                            }}
                          >
                            <img
                              src={googleButton}
                              alt="Download on Google Play"
                              width="100%"
                              height="auto"
                            />
                          </a>
                          {/* <a
                            href="https://appgallery.huawei.com/app/C104770227"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              maxWidth: "200px",
                              margin: "0 auto",
                            }}
                          >
                            <img
                              src={huaweiButton}
                              alt="Download on Huawei"
                              width="100%"
                              height="auto"
                            />
                          </a> */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col>
              <div className="mb-4 mb-lg-0">
                <img
                  src={BannerImage}
                  alt="Hero Image"
                  className="d-block"
                  data-aos="fade-right"
                  data-aos-delay="150"
                  style={{
                    width: "100%",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Row>
        <Row data-aos="fade-up" data-aos-delay="150">
          <p className="prerequisites">
            For your security, please make sure you always install the latest
            version of the app from the App Store or Google Play, or Huawei
            AppGallery. The app supports the following devices and operating
            systems:
            <ul>
              <li>iPhones with iOS 15 or above</li>
              <li>Androids with Android 11 or above</li>
            </ul>
          </p>
        </Row>
      </Container>
    </div>
  );
}

export default InstallApp;
